/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsImageRowData } from './hosports-image-row.data';
import { IHosportsImageRowProps } from './hosports-image-row.props.autogenerated';

export interface IHosportsImageRowViewProps extends IHosportsImageRowProps<IHosportsImageRowData> {

}

/**
 *
 * HosportsImageRow component
 * @extends {React.PureComponent<IHosportsImageRowProps<IHosportsImageRowData>>}
 */
class HosportsImageRow extends React.PureComponent<IHosportsImageRowProps<IHosportsImageRowData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsImageRow;
